import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React, { forwardRef, useMemo } from 'react';
import { autoSizeRootStyles } from './auto-size-root.styles.esm.js';

var _excluded = ["anchorClassName", "children", "className", "direction", "gap", "gapCol", "gapRow", "padding", "paddingX", "paddingY", "scrollable"];
// import { usePropId } from '../../../utils/use-prop-id'

var AutoSizeRoot = /*#__PURE__*/forwardRef(function AutoSizeRoot(props, ref) {
  var _props$anchorClassNam = props.anchorClassName,
    anchorClassName = _props$anchorClassNam === void 0 ? 'csg-tw-auto-size-root' : _props$anchorClassNam,
    children = props.children,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$direction = props.direction,
    direction = _props$direction === void 0 ? 'vertical' : _props$direction,
    gap = props.gap,
    gapCol = props.gapCol,
    gapRow = props.gapRow,
    padding = props.padding,
    paddingX = props.paddingX,
    paddingY = props.paddingY,
    scrollable = props.scrollable,
    rest = _objectWithoutProperties(props, _excluded);
  // const id = usePropId(props.id)
  var classes = useMemo(function () {
    return autoSizeRootStyles.base({
      className: className,
      direction: direction,
      gap: gap,
      gapCol: gapCol,
      gapRow: gapRow,
      padding: padding,
      paddingX: paddingX,
      paddingY: paddingY,
      scrollable: scrollable
    });
  }, [className, direction, gap, gapCol, gapRow, padding, paddingX, paddingY, scrollable]);
  return /*#__PURE__*/React.createElement("div", _extends({
    // id={id}
    ref: ref,
    className: "".concat(anchorClassName, " ").concat(classes)
  }, rest), children);
});
AutoSizeRoot.displayName = 'AutoSizeRoot';

export { AutoSizeRoot as default };
//# sourceMappingURL=auto-size-root.esm.js.map
